import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import spaList from "@config/spa"
import store from '@store'

export default [
  // ===
  // SPA介紹
  // ===
  {
    path: '/spa/:spaAlias?',
    name: 'spa',
    component: () => lazyLoadView(import('@views/Spa/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const spaAlias = routeTo.params.spaAlias;
          const spaList = await store.dispatch('spa/fetchServuceGroup');
          const spaAliasList = spaList.map((item) => `${item.id}`);
          if(store.getters['auth/isLoggedIn']) {
            await store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            });
          }

          if(!spaAlias && spaAliasList.length) {
            return next({
              name: 'spa',
              params: {
                spaAlias: spaAliasList[0]
              }
            })
          }

          const isValidSpaAliasList = () => {
            return !spaAlias || spaAliasList.includes(spaAlias);
          };

          if(!isValidSpaAliasList()) {
            return next({
              name: '404'
            })
          }
          routeTo.params.spaList = spaList.map((item)=> {
            return {
              ...item,
              name: `${item.id}`
            }
          });
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      spaList: route.params.spaList || []
    }),
  },
]
